import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FinalCardView from "./FinalCardView"; // adjust path if needed
import { cardThemes as themes } from "../utils/cardThemes";

const CardUrl = () => {
    const { websiteUrl } = useParams(); // get the code from URL
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!websiteUrl) return;

        fetch(`https://api.nfcdesignstudio.com/API/v1/${websiteUrl}`)
            .then((res) => res.json())
            .then((result) => {
                console.log("Fetched Result:", result);
                setData(result);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching card data:", err);
                setLoading(false);
            });
    }, [websiteUrl]);

    if (loading) return <div style={{ textAlign: "center", marginTop: 50 }}>Loading...</div>;
    if (!data) return <div style={{ textAlign: "center", marginTop: 50 }}>No Data Found</div>;

    const selectedTheme = Array.isArray(themes)
        ? themes.find(theme => theme.id === data.themeId)
        : themes[data.themeId];

    console.log("Selected Theme:", selectedTheme);

    const transformedData = {
        name: data.name || "",
        designation: data.designation || "",
        companyName: data.companyName || "",
        image: data.image || data.image?.[0] || "",

        phoneNumber: data.phoneNumber || "",
        email: data.email || "",

        websiteUrl: data.websiteUrl || "",
        website: data.website || "",
        whatsappChat: data.whatsappChat ? `https://wa.me/${data.whatsappChat}` : "",
        call: data.call || data.phoneNumber || "",
        location: data.location || "",
        address: data.address || "",

        facebookUrl: data.facebookUrl || "",
        linkedinUrl: data.linkedinUrl || "",
        instagramUrl: data.instagramUrl || "",
        twitterUrl: data.twitterUrl || "",
        telegramUrl: data.telegramUrl || "",

        image1: data.images?.[0] || "",
        image2: data.images?.[1] || "",
        image3: data.images?.[2] || "",
        image4: data.images?.[3] || "",
        image5: data.images?.[4] || "",
        image6: data.images?.[5] || "",
        image7: data.images?.[6] || "",
        image8: data.images?.[7] || "",
        image9: data.images?.[8] || "",
        image10: data.images?.[9] || "",
        videoUrl1: data.videoUrl1 || "",
        videoUrl2: data.videoUrl2 || "",
    };

    return (
        <FinalCardView
            data={transformedData}
            theme={selectedTheme}
            userEmail={data.email}
            userMobile={data.phoneNumber}
            isPublicView={true}
        />
    );
};

export default CardUrl;
